import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17 8.798h-1V5.865C16 2.639 13.3 0 10 0S4 2.64 4 5.865v2.933H3c-1.7 0-3 1.27-3 2.933v6.843c0 1.662 1.3 2.933 3 2.933h14c1.7 0 3-1.271 3-2.933v-6.843c0-1.662-1.3-2.933-3-2.933M6 5.865c0-2.15 1.8-3.91 4-3.91s4 1.76 4 3.91v2.933H6zm12 12.709c0 .586-.4.977-1 .977H3c-.6 0-1-.39-1-.977v-6.843c0-.587.4-.978 1-.978h14c.6 0 1 .391 1 .978z"
    }, null, -1)
  ]))]))
}
export default { render: render }